import { Component, Input, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { AngularGridInstance, Formatters, GridOption, FieldType } from 'angular-slickgrid';
import { NotifierService } from 'angular-notifier';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RestApiService } from '../rest-api.service';
import { MessageService } from '../message.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SocketService } from '../socket.service';

@Component({
    selector: 'app-view-ticket-lt',
    templateUrl: './view-ticket-lt.component.html',
    styleUrls: ['./view-ticket-lt.component.css']
})
export class ViewTicketLtComponent implements OnInit, OnDestroy {
    ticketTypeLoaded = false;
    displayed = true;
    folderDisplayed = true;
    cat = [];
    step: string;
    assignGroupLength: number;
    typeChecked: string;
    columnDefinitions = [];
    gridOptions: GridOption;
    gridOptions1: GridOption;
    gridOptions3: GridOption;
    gridOptions4: GridOption;
    gridOptions2: GridOption;
    dataset: any[];
    angularGrid: AngularGridInstance;
    angularGrid1: AngularGridInstance;
    angularGrid2: AngularGridInstance;
    angularGrid3: AngularGridInstance;
    angularGrid4: AngularGridInstance;
    totalData: number;
    selectedTitles = [];
    selectedTitles2 = [];
    gridObj: any;
    gridObj1: any;
    gridObj2: any;
    gridObj3: any;
    gridObj4: any;
    show: boolean;
    selected: number;
    ticketId: string;
    // tType: string;
    defaultStatus = false;
    defaultUser = false;
    defaultNextUser = false;
    name: string;
    desc: string;
    brief: string;
    rDate: string;
    dDate: string;
    comment: string;
    priority: string;
    ticketCreated = false;
    percent: number;
    canForward = false;

    @ViewChild('content') private content;
    ticketTypes: any;
    solution: string;
    types = [];
    rca: string;
    notifier: NotifierService;
    respObject: any;
    clientId: number;
    assignedUser: any;
    assignedGroup: any;
    currentUser: string;
    currentGroup: string;
    groups = [];
    supportGroupSelected: number;
    statusSelected: number;
    users = [];
    status = [];
    userSelected: number;
    assignee_copy: string;
    private groupDetails: any;
    private tId: any;
    lastCatId: number;
    lastParentId: number;
    totalItems: number;
    private statusIndex: any;
    statusName: string;
    private createbyid: any;
    private wfcresultId: any;
    respTime: string;
    comments = [];
    assignedToMe = false;
    closedticket = false;
    endIndicator = true;
    slaViolated = false;
    logs = [];
    private gid: number;
    private gid_copy: number;
    private aid: any;
    count: number;
    solutions = [];
    private modalReference: NgbModalRef;
    folderClicked: any;
    createdByMe = false;
    attachments = [];
    attachment = [];
    replyAttachment = [];
    uploadButtonName = 'Upload File';
    fileUploadUrl: string;
    formData: any;
    menus = [];
    ticketTab = true;
    commentsTab = true;
    solTab = true;
    attachTab = true;
    logTab = true;
    tabs: any;
    private slaTime: any;
    hasFollowupUser: boolean;
    followupUser: string;
    private SLA_INTERVAL_TIME = 60 * 1000;
    slaString: any;
    outerColor: any;
    innerColor: any;
    outerColorResp: any;
    innerColorResp: any;

    masterNameObj = [];
    page = 1;
    MAX_SIZE = 4;
    collectionSize: number;
    LIMIT = 7;
    start = 0;
    isDisabled = true;
    dynamicFields: any;
    private masterName: string;
    masterNameSelected: number;
    data = [];
    viewIncidentData = [];
    columnData = [];
    columnDefinitions1 = [];
    columnDefinitions3 = [];
    columnDefinitions4 = [];
    showGrid = false;
    columnData1 = [];
    columnData3 = [];
    columnData4 = [];
    columnDefinitions2 = [];
    showGrid1 = false;
    showGridForViewIncident = false;
    showGridForAddIncident = false;
    data2 = [];
    masterDataNameSelected: number;
    actions = [];
    statusSeq: number;
    escalatedTicket = false;
    seq: number;
    isAsset: boolean;
    addIncidentData = [];
    selectedTitles4 = [];
    inciId: number;
    isApprovedTicket: boolean;
    isApproved: string;
    worker: any;
    searchTid: string;
    ticketCount: number;
    private addedTicket = [];
    isAddIncident: boolean;
    isViewIncident: boolean;
    userGroupId: number;
    canAddSolution: boolean;
    canAddComment: boolean;
    typeSeq: any;
    subRadioDisplay: boolean;
    subtypes = [];
    subTypeId: any;
    @ViewChild('statusChange') private statusChange;
    PROBLEM_SOLUTION_PROVIDED = 103;
    private INCIDENT_TYPE_SEQ = 1;
    folderLoaded = false;
    solLoaded: boolean;
    comLoaded: boolean;
    resoTime: string;
    hideAttachment: boolean;
    replyHideAttachment: boolean;
    attachMsg: string;
    userGroups = [];
    @ViewChild('groupSelect') private groupSelect;
    private dialogRef: MatDialogRef<any, any>;
    userGroupSelected = 0;
    assetDisplayed: boolean;
    isRInfo: boolean;
    loginName: string;
    email: string;
    mobile: string;
    username: string;
    private baseCategories = [];
    respPercent: number;
    slaStringResp: string;
    slaViolatedResp = false;
    empId: any;
    groupName: string;
    wGroups = [];
    public activateUserReplay: boolean;
    private AWAITING_USER_CLARIFICATION = 12;
    usersReply: string;
    searchType: string;
    searchTypeStatus: string;
    searchText: string;
    private users_copy = [];
    private baseUser: boolean;
    psInfo = [];
    public grpLevel: number;
    statusDisabled: boolean;
    isLowestLevel: boolean;
    lastComment: string;
    solProvided = false;
    diplaySLAMeter: boolean;
    lastSol: string;
    public isSelfAssigned: boolean;
    displayClaimNo: boolean;
    claimNo: string;
    lastCommentUser: string;
    public followUps = [];
    public followUpSelected: number;
    isFollowUp: boolean;
    private ticketTypeSubscription: Subscription;
    private priorityId: number;
    escLevel: string;
    catFilterVal = 0;
    userFilterVal = 0;
    statusComment: string;
    private isCommentRequired: string;
    private commentSubscribe: Subscription;
    private userAuth: Subscription;
    displayNewComment: boolean;
    private dialogRef1: MatDialogRef<any, any>;
    displayNewAttachment: boolean;
    private attachmentSubscribe: Subscription;
    private solSubscribe: Subscription;
    displayNewSolutions: boolean;
    ticketIdSearchLoaded: boolean;
    allStatus = [];
    filterSearchLoaded: boolean;
    categoryLoaded = false;
    inciCategories = [];
    searchCat = [];
    startDate: any;
    endDate: any;
    priorityType: number;
    private storage: any;
    private closeModalSubscribe: Subscription;
    isChangeStatus: boolean;
    private aGrpLvl: number;
    isUserReplied: boolean;
    rowData: any;
    isViewTicket: boolean;
    dataLoaded: boolean;
    nextOffset: number;
    pageSize: number;
    service: any;
    pageSizeObj: any[];
    pageNo: number;
    totalPage: number;
    pageSizeSelected: number;
    paginationObj: any;
    offset: number;
    previousOffset: number;
    page_no: number;
    private masterCloseSubscribeLT: Subscription;
    islead: any;
    isExportDisable: any;
    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
        private modalService: NgbModal, private socketService: SocketService,
        private dialog: MatDialog, notifier: NotifierService, private actRoute: ActivatedRoute) {
        this.notifier = notifier;
        this.masterCloseSubscribeLT = this.messageService.masterCloseModalSubject.subscribe((data) => {
            this.viewTicketList(data, { 'offset': 0, 'paginationType': '' }, 'Ticket');
        });
        // this.attachmentSubscribe = this.socketService.attachmentSubject.subscribe((data) => {
        //     if (this.userGroupId === data.groupId) {
        //         // console.log('-->: ' + JSON.stringify(data));
        //         if (this.tId === data.ticketId) {
        //             this.displayNewAttachment = true;
        //             delete data.ticketId;
        //             delete data.groupId;
        //         }
        //     }
        // });
        // this.solSubscribe = this.socketService.solPrvdSubject.subscribe((data) => {
        //     if (this.userGroupId === data.groupId) {
        //         // console.log('-->: ' + JSON.stringify(data));
        //         if (this.tId === data.ticketId) {
        //             this.displayNewSolutions = true;
        //             this.lastSol = data.solutions;
        //             delete data.ticketId;
        //             delete data.groupId;
        //             this.solutions.unshift(data);
        //         }
        //     }
        // });
    }


    angularGridReady(angularGrid: AngularGridInstance) {
        // console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    onPager(pageNumber: number): void {
        // console.log('Pager event Is: ', pageNumber);
        this.start = (pageNumber * this.LIMIT) - this.LIMIT;
        this.folderClick(this.folderClicked);
        // console.log('start:' + this.start);
    }

    ngOnInit() {
        this.islead = false;
        this.isExportDisable = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.page_no = 0;
        this.pageSizeObj = this.messageService.searchPagination;
        this.pageSizeSelected = this.messageService.searchPageSelected;
        this.pageSize = this.messageService.searchPageSize;
        this.pageNo = 0;
        this.paginationObj = { 'offset': this.nextOffset, 'paginationType': '' };
        this.totalPage = 0;
        // -----------------------------------------
        this.dataLoaded = true;
        this.isViewTicket = true;
        this.dynamicFields = [];
        this.rDate = '';
        this.dDate = '';
        this.subRadioDisplay = false;
        this.assetDisplayed = false;
        this.isRInfo = false;
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        // this.percent = 0;
        this.searchType = 'id';
        this.searchTypeStatus = 'opn';
        this.columnDefinitions = [];

        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.userGroups = this.messageService.groupId;
            if (this.userGroups !== undefined) {
                if (this.messageService.getSupportGroup() === null) {
                    this.userGroupId = this.userGroups[0].groupId;
                    this.groupName = this.userGroups[0].grpName;
                    this.grpLevel = this.userGroups[0].level;

                } else {
                    const group = this.messageService.getSupportGroup();
                    // // console.log(group, typeof group);
                    this.userGroupId = group.groupId;
                    this.groupName = group.grpName;
                    this.grpLevel = group.level;
                }
                this.userGroupSelected = this.userGroupId;
            }
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.clientId = auth[0].clientId;
                this.userGroups = auth[0].groupId;
                if (this.userGroups !== undefined) {
                    if (this.messageService.getSupportGroup() === null) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;

                    } else {
                        const group = this.messageService.getSupportGroup();
                        // // console.log(group, typeof group);
                        this.userGroupId = group.groupId;
                        this.groupName = group.grpName;
                        this.grpLevel = group.level;
                    }
                    this.userGroupSelected = this.userGroupId;
                }
                this.onPageLoad();
            });
        }
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.dataset = [];
    }

    onPageLoad() {
        this.islead = false;
        this.isExportDisable = false;
        console.log('Group Level ===> ' + this.grpLevel);
        if (this.grpLevel === 1) {
            this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
                this.respObject = res3;
                if (this.respObject.success) {
                    this.islead = this.respObject.details[0].is_spoc;
                    this.isExportDisable = this.islead;
                }
            });
        } else if (this.grpLevel === 2) {
            this.isExportDisable = true;
        } else {
            this.isExportDisable = false;
        }

        this.ticketTypeSubscription = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
            this.respObject = res1;
            // // console.log(JSON.stringify(this.respObject.details));
            // console.log('-----------inside  View Ticket');
            this.ticketTypeLoaded = true;
            if (this.respObject.success) {
                this.storage = JSON.parse(sessionStorage.getItem('dd'));
                this.types = this.respObject.details;
                if (this.storage === null) {
                    this.typeChecked = this.types[0].id;
                    this.seq = this.types[0].seq;
                    // // console.log('this.seq1:' + this.seq);
                    if (this.seq === this.INCIDENT_TYPE_SEQ && this.types[0].asset === 'true') {
                        this.assetDisplayed = true;
                    } else {
                        this.assetDisplayed = false;
                    }
                } else {
                    const type = this.storage.type;
                    // this.folderClicked = this.storage.id;
                    this.catFilterVal = this.storage.cat;
                    this.userFilterVal = this.storage.user;
                    this.types[0].checked = false;
                    for (let i = 0; i < this.types.length; i++) {
                        // console.log(this.types[i].id, type);
                        if (this.types[i].id === type) {
                            this.typeChecked = this.types[i].id;
                            this.types[i].checked = true;
                            this.seq = this.types[i].seq;
                            this.types[i].checked = true;
                            break;
                        }
                    }
                    // console.log('---------> type: ' + this.typeChecked);
                }
                // this.messageService.setTicketType(this.typeChecked);
                // // console.log(typeof this.seq, this.seq);

                for (let i = 0; i < this.types.length; i++) {
                    if (this.types[i].seq === this.INCIDENT_TYPE_SEQ) {
                        this.inciId = this.types[i].id;
                        break;
                    }
                }
                this.getColumnDefintion();
                this.getDynamicMenuTicketTypeWise();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    exportToExcel() {
        console.log('Export To Excel Clicked .......... ' + this.step);
        if (this.totalData === 0) {
            this.notifier.notify('error', 'No Data To Export');
        } else {
            this.pageSize = this.totalData;
            this.viewTicketList(this.step, { 'offset': 0, 'paginationType': '' }, 'Export');
        }

    }

    getDynamicMenuTicketTypeWise() {
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.typeChecked,
            this.messageService.getUserId(), 1, this.userGroupId).subscribe((res2) => {
                this.respObject = res2;
                // console.log(JSON.stringify(this.respObject));
                this.folderLoaded = true;
                if (this.respObject.success) {
                    this.menus = this.respObject.details;
                    if (this.storage !== null) {
                        const type = this.storage.type;
                        if (type === this.typeChecked) {
                            // console.log(this.storage.id, typeof this.storage.id);
                            if (this.storage.id) {
                                sessionStorage.setItem('dd', JSON.stringify({
                                    type: this.typeChecked,
                                    seq: this.storage.seq,
                                    user: this.storage.user,
                                    cat: this.storage.cat
                                }));
                                this.clickedFilter(this.storage.id);
                            }
                        } else {
                            if (this.menus.length > 0) {
                                sessionStorage.setItem('dd', JSON.stringify({
                                    type: this.typeChecked,
                                    seq: this.seq,
                                    user: this.storage.user,
                                    cat: this.storage.cat
                                }));
                                this.clickedFilter(this.menus[0].fid);
                            }
                        }
                    } else {
                        if (this.menus.length > 0) {
                            sessionStorage.setItem('dd', JSON.stringify({ type: this.typeChecked, seq: this.seq, user: 0, cat: 0 }));
                            this.clickedFilter(this.menus[0].fid);
                        } else {
                            sessionStorage.setItem('dd', JSON.stringify({
                                type: this.typeChecked,
                                seq: this.seq,
                                user: 0,
                                cat: 0
                            }));
                        }
                    }
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    toggleViews() {
        this.displayed = !this.displayed;
    }

    toggleFolderViews() {
        this.folderDisplayed = !this.folderDisplayed;
    }

    changeRouting() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
        // this.route.navigate(['ticket/dashboard']);
    }


    onButtonChange(value) {
        // // console.log(value.value);
        this.typeChecked = value.value.id;
        this.seq = value.value.seq;
        this.getColumnDefintion();
        this.getDynamicMenuTicketTypeWise();
        this.dataset = [];
        this.totalItems = 0;

        // if (value.value.seq === 2) {
        //   this.subRadioDisplay = true;
        //   this._rest.getSubTicketType(this.clientId, this.typeChecked).subscribe((res) => {
        //     this.respObject = res;
        //     // console.log(JSON.stringify(this.respObject));
        //     if (this.respObject.success) {
        //       this.subtypes = this.respObject.details;
        //       this.subTypeId=this.respObject.details[0].id;
        //     } else {
        //       this.notifier.notify('error', this.respObject.errorMessage);
        //     }
        //   }, (err) => {
        //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
        //   });
        // } else {
        //   this.subRadioDisplay = false;
        // }
    }

    getColumnDefintion() {
        this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.typeChecked).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                const data = this.respObject.details;
                // // console.log(JSON.stringify(data));
                this.columnDefinitions = [
                    // {id: 'id', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true},
                    {
                        id: 'ticket_id',
                        name: 'Ticket Id',
                        field: 'ticket_id',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    }, {
                        id: 'entity_code1',
                        name: 'Entity',
                        field: 'entity_code1',
                        minWidth: 70,
                        sortable: true,
                        filterable: true
                    }, {
                        id: 'ic1',
                        name: 'IC',
                        field: 'ic1',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    }, {
                        id: 'unit1',
                        name: 'Unit',
                        field: 'unit1',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'createdBy',
                        name: 'Created By',
                        field: 'createdBy',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'createdSince',
                        name: 'Created Since',
                        field: 'createdSince',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        // type: FieldType.dateIso
                    },
                    {
                        id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 150, filterable: true
                    },
                    {
                        id: 'reqInfo',
                        name: 'RequesterInfo',
                        field: 'reqInfo',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'assignee',
                        name: 'Assignee',
                        field: 'assignee',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'LEVELSHORTDESC',
                        name: 'Group',
                        field: 'LEVELSHORTDESC',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'dDate',
                        name: 'Due Date',
                        field: 'dDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        // type: FieldType.dateIso
                    },
                    {
                        id: 'updateDate',
                        name: 'Last Update Date',
                        field: 'updateDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        // type: FieldType.dateIso
                    },
                    {
                        id: 'updateBy',
                        name: 'Last Updated By',
                        field: 'updateBy',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'closureDate',
                        name: 'Closure Date',
                        field: 'ticketCloseDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'escLevel',
                        name: 'Escalation Level',
                        field: 'escalated_to_grp_nm',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                    }
                    // ,
                    // {
                    //     id: 'unit',
                    //     name: 'UNIT',
                    //     field: 'unit',
                    //     minWidth: 150,
                    //     sortable: true,
                    //     filterable: true
                    // },
                    // {
                    //     id: 'location',
                    //     name: 'Location',
                    //     field: 'location',
                    //     minWidth: 150,
                    //     sortable: true,
                    //     filterable: true
                    // },
                    // {
                    //     id: 'grade',
                    //     name: 'Grade',
                    //     field: 'grade',
                    //     minWidth: 150,
                    //     sortable: true,
                    //     filterable: true
                    // },
                    // {
                    //     id: 'overseas',
                    //     name: 'Overseas',
                    //     field: 'overseas',
                    //     minWidth: 150,
                    //     sortable: true,
                    //     filterable: true
                    // },
                    // {
                    //     id: 'sm',
                    //     name: 'Grade',
                    //     field: 'sm',
                    //     minWidth: 150,
                    //     sortable: true,
                    //     filterable: true
                    // }
                ];
                if (this.grpLevel !== 0) {
                    this.columnDefinitions.push({
                        id: 'priority',
                        name: 'Priority',
                        field: 'priority',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    });
                }
                for (let i = 0; i < data.length; i++) {
                    this.columnDefinitions.push({
                        id: data[i].field,
                        name: data[i].name,
                        field: data[i].field,
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    });
                }
                const classes = document.getElementsByClassName('search-filter');
                for (let i = 0; i < classes.length; i++) {
                    classes[i].setAttribute('placeholder', '');
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    onCellClicked(e, args) {
        const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
        const data = selectedRow.dataContext;
        this.messageService.setModalData(data);
    }

    terminateWorker() {
        if (this.worker) {
            this.worker.terminate();
        }
    }


    // checkCanAddSolution() {
    //     let matched = false;
    //     for (let i = 0; i < this.wGroups.length; i++) {
    //         if (this.wGroups[i].id === this.userGroupId) {
    //             matched = true;
    //             this.canAddSolution = true;
    //             break;
    //         }
    //     }
    //     if (!matched) {
    //         this.canAddSolution = false;
    //     }
    // }

    folderClick(value) {
        // console.log('clicked: ' + value, this.typeChecked, this.userGroupId);
        this.folderClicked = value;

        if (!this.typeChecked) {
            alert('Select Ticket Type First');
        } else {
            this.viewTicketList(value, { 'offset': 0, 'paginationType': '' }, 'Ticket');
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    viewTicketList(value, paginationObj, type) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        if (offset === 0) {
            this.page_no = 0;
        }
        const params = {
            user_id: this.messageService.getUserId(),
            ticketTypeId: this.typeChecked,
            supportgrp_id: this.userGroupId,
            seq: this.seq,
            clientId: this.clientId,
            menuId: value,
            catFilterVal: this.catFilterVal,
            userFilterVal: this.userFilterVal,
            page_size: this.pageSize,
            nextOffset: offset,
            paginationType: paginationType,
            specialFilterVal: '0',
            isLNTSSC: '1',
        };
        this.dataLoaded = false;
        this._rest.getDynamicMenuTicketDtls_new(params).subscribe((res1) => {
            if (type === 'Export') {
                console.log('Exporting DATA ===>');
                this.respObject = res1;
                if (this.respObject.success) {
                    const dataExcel = this.respObject.details.dataObj;
                    this.messageService.exportAsExcelFile(dataExcel);
                    this.dataLoaded = true;
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            } else {
                console.log('Displaying DATA IN GRID ===>')
                this.displayTicket(res1, offset, paginationType);
            }

        }, (err) => {
            // this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
        const data = {
            groupId: this.userGroupId,
            user_id: this.messageService.getUserId(),
            type: value,
            clientId: this.clientId
        };
        this._rest.updateOfflineNotificationData(data).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
            }
        });
    }

    onCellChanged(e, args) {
        // console.log(args.item);
    }

    handleSelectedRowsChanged(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj.getDataItem(idx);
                return item || '';
            });
            if (this.selectedTitles.length > 0) {
                this.show = true;
                this.selected = this.selectedTitles.length;
            } else {
                this.show = false;
            }
            // console.log(JSON.stringify(this.selectedTitles));
        }
    }

    onSelectGroup() {
        // // console.log(typeof this.userGroupSelected);
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });
            this.dataset = [];
            this.totalItems = 0;
            this.onPageLoad();
        }
    }

    displayTicket(res1, offset, paginationType) {
        // console.log('AAAAAAAAAAAAAA');
        this.respObject = res1;
        this.dataLoaded = true;
        if (this.respObject.success) {

            // // console.log(JSON.stringify(this.respObject));
            // this.types = this.respObject.details;
            this.dataset = [];

            const uniqueData = this.respObject.details.dataObj.filter(
                (item, index, self) =>
                  index === self.findIndex((obj) => obj.id === item.id)
              );


            for (let i = 0; i < uniqueData.length; i++) {
                // if (this.respObject.details[i].id === 51) {
                //     // console.log(new Date(this.respObject.details[i].createdSince));
                // }
                uniqueData[i].createdSince =
                    this.messageService.datePipeFunc(uniqueData[i].createdSince);
                    uniqueData[i].dDate =
                    this.messageService.datePipeFunc(uniqueData[i].dDate);
                    uniqueData[i].updateDate =
                    this.messageService.datePipeFunc(uniqueData[i].updateDate);
                if (uniqueData[i].ticketCloseDate === undefined ||
                    uniqueData[i].ticketCloseDate === '' ||
                    uniqueData[i].ticketCloseDate === null) {
                    uniqueData[i].ticketCloseDate = '';
                } else {
                    uniqueData[i].ticketCloseDate =
                        this.messageService.datePipeFunc(uniqueData[i].ticketCloseDate);
                }
                uniqueData[i].requestedDate =
                    this.messageService.datePipeFunc(uniqueData[i].requestedDate);
            }
            // this.dataset = this.respObject.details;
            // this.totalItems = this.dataset.length;
            // // console.log('this.seq:5' + this.seq);
            // ========================================================================
            if (offset === 0) {
                this.totalData = this.respObject.details.totalData[0].count;
                this.totalPage = this.respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (uniqueData.length > 0) {
                this.dataset = uniqueData;
                this.nextOffset = this.respObject.details.nextOffset;
                this.offset = this.respObject.details.nextOffset;
                this.previousOffset = this.respObject.details.previousOffset;
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
                if (this.page_no === 1) {
                    this.previousOffset = 0;
                }
            } else if (uniqueData.length === 0 && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
            // console.log('n==' + this.nextOffset + '==p===' + this.previousOffset + '===totalData==' + this.totalData + '===pageSize===' +
            //     this.pageSize + '===pageno===' + this.page_no);
            // ========================================================================
            // this.gridOptions = Object.assign({}, this.gridOptions);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }

    onSubButtonChange(value) {
        this.subTypeId = value.value.id;
        // // console.log(this.subTypeId);
    }

    clickedFilter(fid: any) {
        console.log('fid ==> ' + fid);
        this.step = fid;
        const storage = JSON.parse(sessionStorage.getItem('dd'));
        storage.id = fid;
        sessionStorage.setItem('dd', JSON.stringify(storage));
        this.folderClick(fid);
    }

    getNextData() {
        this.viewTicketList(this.folderClicked, { 'offset': this.nextOffset, 'paginationType': 'next' }, 'Ticket');
    }

    getPreviousData() {
        this.viewTicketList(this.folderClicked, { 'offset': this.previousOffset, 'paginationType': 'prev' }, 'Ticket');
    }

    onPageSizeChange(value: any) {
        this.pageSize = this.pageSizeObj[value].value;
        this.viewTicketList(this.folderClicked, { 'offset': 0, 'paginationType': '' }, 'Ticket');
    }

    ngOnDestroy(): void {
        if (this.ticketTypeSubscription) {
            this.ticketTypeSubscription.unsubscribe();
        }
        if (this.masterCloseSubscribeLT) {
            this.masterCloseSubscribeLT.unsubscribe();
        }
        // if (this.closeModalSubscribe) {
        //     this.closeModalSubscribe.unsubscribe();
        // }
    }

    getTableData(value) {
        this.dataset = value.dataset;
    }
}
